
export default function ValuesSection() {
  const values = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Conscious Leadership',
      description: 'We lead with awareness, integrity, and purpose, creating positive impact in every decision and action.',
      image: 'https://public.readdy.ai/ai/img_res/8c0fd178e18b3e6fe5d878de8746020f.jpg'
    },
    {
      icon: 'ri-heart-3-line',
      title: 'Authentic Connection',
      description: 'We believe in the power of genuine relationships built on trust, vulnerability, and mutual growth.',
      image: 'https://readdy.ai/api/search-image?query=Two%20diverse%20Black%20and%20Latino%20business%20professionals%20shaking%20hands%20with%20genuine%20smiles%20in%20warm%20golden-lit%20luxury%20office%2C%20representing%20authentic%20connection%20and%20trust%2C%20professional%20photography%2C%20only%20people%20of%20color%2C%20no%20white%20people&width=400&height=300&seq=authentic-connection-diverse&orientation=landscape'
    },
    {
      icon: 'ri-infinity-line',
      title: 'Abundant Mindset',
      description: 'We operate from a place of abundance, knowing there is enough success, wealth, and joy for everyone.',
      image: 'https://readdy.ai/api/search-image?query=Overflowing%20golden%20cornucopia%20with%20coins%2C%20gems%2C%20and%20prosperity%20symbols%20on%20a%20marble%20surface%20with%20warm%20lighting%2C%20representing%20abundance%20mindset%20and%20infinite%20possibilities%2C%20luxury%20still%20life%20photography&width=400&height=300&seq=abundant-mindset&orientation=landscape'
    },
    {
      icon: 'ri-seedling-line',
      title: 'Continuous Growth',
      description: 'We are committed to lifelong learning, evolution, and the expansion of our consciousness and capabilities.',
      image: 'https://readdy.ai/api/search-image?query=Young%20golden%20tree%20growing%20from%20rich%20soil%20with%20sunlight%20streaming%20through%2C%20representing%20continuous%20growth%20and%20potential%2C%20natural%20luxury%20aesthetic%2C%20inspiring%20and%20hopeful%20atmosphere&width=400&height=300&seq=continuous-growth&orientation=landscape'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Impact',
      description: 'We think beyond ourselves, creating solutions and legacies that benefit humanity and future generations.',
      image: 'https://readdy.ai/api/search-image?query=Golden%20globe%20surrounded%20by%20interconnected%20light%20networks%20representing%20global%20impact%20and%20connection%2C%20floating%20above%20elegant%20hands%20in%20a%20luxury%20setting%2C%20high-tech%20spiritual%20aesthetic&width=400&height=300&seq=global-impact&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Spiritual Integrity',
      description: 'We honor the sacred in all aspects of life, aligning our actions with our highest values and purpose.',
      image: 'https://readdy.ai/api/search-image?query=Ancient%20golden%20scales%20of%20justice%20balanced%20perfectly%20on%20a%20marble%20altar%20with%20soft%20divine%20light%20streaming%20down%2C%20representing%20spiritual%20integrity%20and%20moral%20balance%2C%20sacred%20luxury%20aesthetic&width=400&height=300&seq=spiritual-integrity&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
            Our Sacred <span className="text-amber-600">Values</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            These core principles guide every aspect of our movement, from individual transformation to global impact. They form the foundation of our community and the compass for our collective journey.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div key={index} className="group bg-slate-50 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={value.image}
                  alt={value.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <div className="w-12 h-12 bg-white/90 rounded-full flex items-center justify-center">
                    <i className={`${value.icon} text-xl text-amber-600`}></i>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-slate-900 mb-3">{value.title}</h3>
                <p className="text-slate-600 leading-relaxed">{value.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-amber-50 to-yellow-50 rounded-2xl p-8 border border-amber-200">
            <h3 className="text-2xl font-bold text-slate-900 mb-4">Live These Values Daily</h3>
            <p className="text-slate-600 mb-6 max-w-2xl mx-auto">
              Our values aren't just words on a page—they're a way of life. Join our community and discover how these principles can transform your approach to wealth, relationships, and legacy.
            </p>
            <button className="bg-gradient-to-r from-amber-600 to-yellow-500 hover:from-amber-700 hover:to-yellow-600 text-white px-8 py-3 rounded-lg font-medium transition-all duration-200 cursor-pointer whitespace-nowrap">
              Explore Our Programs
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
